import axios from "axios";
import { received } from "../DocumentationReducer";
import { baseURL } from "../thunks";

export const markNotificationsRead =
  ({ arr }) =>
  async (dispatch) => {
    try {
      const postReq = await axios({
        method: "post",
        url: baseURL + "documentation/notifications/mark-read",
        data: arr,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      return postReq;
    } catch (error) {
      console.log(error);
      dispatch(received({ error: true }));
    }
  };
